import { useOsVersionsQuery } from 'services/api/creativeServer';
import { Option } from 'containers/PodHomePage/components/Screen/components/OnDemandModal/types';

export const useOSVersionSearch = (adslot: string) => {
  const { data, isFetching, isLoading } = useOsVersionsQuery(
    { adslot },
    { skip: !adslot },
  );

  // API returns { osv: [...] }
  const list = Array.isArray(data?.osv) ? data.osv : [];

  const options: Option[] = list.map(v => ({
    key: v,
    value: v,
    label: v,
  }));

  return {
    options,
    isLoading,
    isFetching,
  };
};
